import { jsx as l } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { UnstyledButton as V } from "../UnstyledButton/UnstyledButton.js";
import { buttonIconVariants as n } from "./ButtonIcon.variants.js";
const t = n.definition().defaultVariants, v = d(
  ({
    appearance: a = t.appearance,
    children: f,
    className: e,
    enableGroupHover: m = !1,
    isDisabled: o = !1,
    isDisabledFocusable: r = !1,
    size: s = t.size,
    variant: i = t.variant,
    ...p
  }, c) => {
    const { root: u } = n;
    return /* @__PURE__ */ l(
      V,
      {
        className: u({
          appearance: a,
          className: e,
          enableGroupHover: m,
          isDisabled: o,
          isDisabledFocusable: r,
          size: s,
          variant: i
        }),
        isDisabled: o,
        isDisabledFocusable: r,
        ref: c,
        ...p,
        children: f
      }
    );
  }
);
export {
  v as ButtonIcon
};
